(function (Buffer){
var util = require('util');
var EMPTY = 0, BODY = 1;
var BINARYLENGTH = 2, BINARYBODY = 3;
function Receiver() {
    if (this instanceof Receiver === false) {
        throw new TypeError('Classes can\'t be function-called');
    }
    this.state = EMPTY;
    this.buffers = [];
    this.messageEnd = -1;
    this.spanLength = 0;
    this.dead = false;
    this.onerror = function () {
    };
    this.ontext = function () {
    };
    this.onbinary = function () {
    };
    this.onclose = function () {
    };
    this.onping = function () {
    };
    this.onpong = function () {
    };
}
module.exports = Receiver;
Receiver.prototype.add = function (data) {
    var self = this;
    function doAdd() {
        if (self.state === EMPTY) {
            if (data.length == 2 && data[0] == 255 && data[1] == 0) {
                self.reset();
                self.onclose();
                return;
            }
            if (data[0] === 128) {
                self.messageEnd = 0;
                self.state = BINARYLENGTH;
                data = data.slice(1);
            } else {
                if (data[0] !== 0) {
                    self.error('payload must start with 0x00 byte', true);
                    return;
                }
                data = data.slice(1);
                self.state = BODY;
            }
        }
        if (self.state === BINARYLENGTH) {
            var i = 0;
            while (i < data.length && data[i] & 128) {
                self.messageEnd = 128 * self.messageEnd + (data[i] & 127);
                ++i;
            }
            if (i < data.length) {
                self.messageEnd = 128 * self.messageEnd + (data[i] & 127);
                self.state = BINARYBODY;
                ++i;
            }
            if (i > 0)
                data = data.slice(i);
        }
        if (self.state === BINARYBODY) {
            var dataleft = self.messageEnd - self.spanLength;
            if (data.length >= dataleft) {
                self.buffers.push(data);
                self.spanLength += dataleft;
                self.messageEnd = dataleft;
                return self.parse();
            }
            self.buffers.push(data);
            self.spanLength += data.length;
            return;
        }
        self.buffers.push(data);
        if ((self.messageEnd = bufferIndex(data, 255)) != -1) {
            self.spanLength += self.messageEnd;
            return self.parse();
        } else
            self.spanLength += data.length;
    }
    while (data)
        data = doAdd();
};
Receiver.prototype.cleanup = function () {
    this.dead = true;
    this.state = EMPTY;
    this.buffers = [];
};
Receiver.prototype.parse = function () {
    var output = new Buffer(this.spanLength);
    var outputIndex = 0;
    for (var bi = 0, bl = this.buffers.length; bi < bl - 1; ++bi) {
        var buffer = this.buffers[bi];
        buffer.copy(output, outputIndex);
        outputIndex += buffer.length;
    }
    var lastBuffer = this.buffers[this.buffers.length - 1];
    if (this.messageEnd > 0)
        lastBuffer.copy(output, outputIndex, 0, this.messageEnd);
    if (this.state !== BODY)
        --this.messageEnd;
    var tail = null;
    if (this.messageEnd < lastBuffer.length - 1) {
        tail = lastBuffer.slice(this.messageEnd + 1);
    }
    this.reset();
    this.ontext(output.toString('utf8'));
    return tail;
};
Receiver.prototype.error = function (reason, terminate) {
    this.reset();
    this.onerror(reason, terminate);
    return this;
};
Receiver.prototype.reset = function (reason) {
    if (this.dead)
        return;
    this.state = EMPTY;
    this.buffers = [];
    this.messageEnd = -1;
    this.spanLength = 0;
};
function bufferIndex(buffer, byte) {
    for (var i = 0, l = buffer.length; i < l; ++i) {
        if (buffer[i] === byte)
            return i;
    }
    return -1;
}
}).call(this,require("buffer").Buffer)
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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